import api from '../api'
import { LoadbalancerGroup } from '../createLoadbalancerGroup'

export function getLoadbalancerGroup(id: number): Promise<LoadbalancerGroup> {
    return api.get({ path: '/loadbalancergroups/' + id })
}
